import { Button, Modal, Title, useToast } from "@validereinc/common-components";
import { toTitleCaseString } from "@validereinc/utilities";
import * as PropTypes from "prop-types";
import React, { useState } from "react";

const DeleteModal = ({
  open,
  onClose,
  doDelete,
  onDelete,
  entityName = "entity",
  instanceName,
  action = { present: "delete", past: "deleted" },
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { toast } = useToast();
  const formattedName = `"${instanceName}"`;

  const handleDelete = async () => {
    try {
      setIsSubmitting(true);
      await doDelete();

      toast.push({
        intent: "success",
        description: `Successfully ${action.past} ${formattedName}.`,
      });

      onDelete();
      setIsSubmitting(false);
      onClose();
    } catch (err) {
      setIsSubmitting(false);
      toast.push({
        intent: "error",
        description: `Unable to ${action.present} ${formattedName}.`,
      });
    }
  };

  const actionLabel = toTitleCaseString(action.present, { intent: "ui" });

  return (
    <Modal
      open={open}
      onClose={onClose}
    >
      <Modal.Header>
        <Title>{`${actionLabel} ${formattedName}?`}</Title>
      </Modal.Header>
      <Modal.Body>
        {`Are you sure you want to ${
          action.present
        } this ${entityName.toLowerCase()}? This action cannot be undone.`}
      </Modal.Body>

      <Modal.Footer className="clearfix modal-footer">
        <Button
          onClick={handleDelete}
          variant="error"
          disabled={isSubmitting}
        >
          {actionLabel}
        </Button>

        <Button onClick={onClose}>Cancel</Button>
      </Modal.Footer>
    </Modal>
  );
};

DeleteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  doDelete: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  entityName: PropTypes.string,
  instanceName: PropTypes.string.isRequired,
  action: PropTypes.object,
};

export default DeleteModal;
